import { CommonPageOGCard, EOGType, ICommonPageOGCardProps, IOGImage } from '@lemon8/web-app-shared/ssr';
import { useHomepageTDK } from '~/utils/use-page-tdk';
import { getCanonicalUrl } from './tdk';
import Logo from '@lemon8/web-app-shared/logo/square_fullcolor.png';

export const HomepageOpenGraph = () => {
  const canonicalUrl = getCanonicalUrl();

  const { title, description } = useHomepageTDK();

  const getOGImageMeta = (): IOGImage | null => {
    return {
      url: Logo,
    };
  };

  const ogCardInfo: ICommonPageOGCardProps = {
    ogUrl: canonicalUrl,
    ogTitle: title,
    ogDescription: description,
    ogMediaMetaInfo: getOGImageMeta(),
    ogType: EOGType.Website,
  };
  return <CommonPageOGCard {...ogCardInfo} />;
};
